// Which destination ports "belong" to a locale's country money-page — the country's own seaports
// plus the gateway ports its importers route through. Drives which lanes get a localized variant +
// hreflang alternate. Source of truth = i18n/data.mjs GATEWAYS (shared with prerender).
import { GATEWAYS } from '../i18n/data.mjs'

/** True if this destination is a gateway for `locale`'s country page. */
export function isGatewayFor(locale: string, podCode?: string | null, podCountry?: string | null): boolean {
  const g = GATEWAYS[locale]
  if (!g) return false
  const code = (podCode || '').toUpperCase()
  if (g.country && (podCountry || '').toLowerCase() === g.country.toLowerCase()) return true
  return g.podCodes.includes(code)
}

/** Every locale whose country page claims this destination (for a lane's hreflang alternates). */
export function localesForPod(podCode?: string | null, podCountry?: string | null): string[] {
  return Object.keys(GATEWAYS).filter((code) => isGatewayFor(code, podCode, podCountry))
}
